import { StoplossClaimStatus, StoplossClaimStatusType } from "@/types";

export const IN_PROCESS_STATUSES = [
  StoplossClaimStatus.NEW,
  StoplossClaimStatus.IN_PROCESS,
  StoplossClaimStatus.PENDED,
] as const;
export const SUBMITTED_STATUSES = [
  StoplossClaimStatus.SUBMITTED,
  StoplossClaimStatus.PARTIALLY_REIMBURSED,
  StoplossClaimStatus.REIMBURSED,
] as const;
export const SUBMITTED_ONLY_STATUSES = [StoplossClaimStatus.SUBMITTED] as const;
export const REIMBURSED_STATUSES = [StoplossClaimStatus.REIMBURSED, StoplossClaimStatus.PARTIALLY_REIMBURSED] as const;
export const DENIED_STATUSES = [StoplossClaimStatus.DENIED] as const;

export const STOPLOSS_STATUS_GROUP_LABELS = {
  IN_PROCESS: "In Process",
  SUBMITTED: "Submitted",
} as const;

export const STOPLOSS_CLAIM_STATUS_GROUPS = {
  IN_PROCESS: IN_PROCESS_STATUSES,
  SUBMITTED: SUBMITTED_STATUSES,
  DENIED: DENIED_STATUSES,
} as const;

// Type guards for runtime checks
export const isInProcessStatus = (status: StoplossClaimStatusType): boolean => {
  return (IN_PROCESS_STATUSES as readonly string[]).includes(status);
};

export const isSubmittedStatus = (status: StoplossClaimStatusType): boolean => {
  return (SUBMITTED_STATUSES as readonly string[]).includes(status);
};

// Helper to get the group name for a status
export const getStatusGroup = (status: StoplossClaimStatusType): StoplossClaimStatusType | "other" => {
  if (isInProcessStatus(status)) return StoplossClaimStatus.IN_PROCESS;
  if (isSubmittedStatus(status)) return StoplossClaimStatus.SUBMITTED;
  return "other";
};
